import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type IFlameSignalData } from '../services/getFlameSignaGraphKPIDataService'

export interface IFlameSignalDataState {
  isLoading: boolean
  error: string | null
  flameSignalData: any | null
  httpStatus: number | undefined
}

const initialState: IFlameSignalDataState = {
  isLoading: false,
  error: null,
  flameSignalData: null,
  httpStatus: 0
}

const flameSignalKpiDataSlice = createSlice({
  name: 'flameSignalKpiData',
  initialState,
  reducers: {
    flameSignalKPIDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        flameSignalData: null,
        httpStatus: 0
      }
    },
    flameSignalKPIDataUpdateAction: (state, action: PayloadAction<{ data: IFlameSignalData, httpStatus: number }>) => {
      console.log(action, 'datadatasa')
      return {
        isLoading: false,
        error: null,
        flameSignalData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    flameSignalKPIDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        flameSignalData: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  flameSignalKPIDataLoadingAction,
  flameSignalKPIDataUpdateAction,
  flameSignalKPIDataErrorAction
} = flameSignalKpiDataSlice.actions

export default flameSignalKpiDataSlice.reducer
